import { apiPrefix } from '@/request/config';
import Http from '@/request/Http';
import { isWMSdk } from '@/tool/profile';
import { checkOS, isWindows } from '@/tool/tool';

export function getSystem() {
  return Http.get('/system');
}
export function getPwdlevel() {
  return Http.get('/system/pwdlevel');
}

export function setMail(mail, password, server, port, mailenabled) {
  return Http.post('/system/mail', {
    flag: 1,
    mail,
    password,
    server,
    port,
    mailenabled,
  });
}

export function setOverTime(date) {
  return Http.get('/system/date', {
    date,
  });
}

export function resetMail() {
  return Http.post('/system/mail', { flag: 0 });
}

export function getbackPassword(companycode, username) {
  return Http.get('/system/password', {
    username,
    companycode,
  });
}

export function getSocketLink() {
  // TODO: 是否判断以下系统，非windows进行提示
  let bit = '';
  if (isWindows()) {
    const agent = navigator.userAgent.toLowerCase();
    if (agent.indexOf('win32') >= 0) {
      bit = 'win32';
    } else bit = 'win64';
  }
  return Http.get('/commprograms', { os: checkOS(), bit, type: isWMSdk() ? 'wm' : 'hm' });
}

export function getCustomizationInfo() {
  return Http.get('/system/customization/info');
}

export function setCustomizationInfo(
  name,
  title,
  producer,
  url,
  keycabinet_name,
  sequence,
  bititle
) {
  return Http.post('/system/customization/info', {
    name,
    title,
    producer,
    url,
    keycabinet_name,
    sequence,
    bititle,
  });
}

export function resetCustomizationInfo() {
  return Http.delete('/system/customization/info');
}

export function getLogoUploadAddress(sequence) {
  // TODO: 这个地方地址后期规范以下，不带api/v1
  return `${apiPrefix}/system/customization/logo?sequence=${sequence}`;
}

export function getKeycabinetLogoUploadAddress(sequence) {
  // TODO: 这个地方地址后期规范以下，不带api/v1
  return `${apiPrefix}/system/customization/keycabinet/logo?sequence=${sequence}`;
}

export function setSystemCode() {
  return Http.post('/system/secret');
}

export function verifLicenseUSBKey() {
  return Http.post('/system/license/usb_key');
}

export function getLicenseRequestCode() {
  return Http.get('/system/license/request_code');
}

export function verifyLicenseActivateCode(code) {
  console.log(code, typeof code);
  return Http.post('/system/license/activate_code', { code });
}

export function getBackupList(page, pagesize) {
  return Http.get('/backups', { page, pagesize });
}

export function setAutoBackup(status) {
  // TODO: 这个url命名不规范
  return Http.put(`/backups/auto`, null, {
    flag: status,
  });
}

export function createBackup(backupName) {
  return Http.post('/backups', {
    name: backupName,
    timeout: 20 * 60 * 1000,
  });
}

export function deleteBackup(backup) {
  return Http.delete(`/backups/${backup.id}`);
}

export function restoreBackup(backup, password) {
  return Http.post(`/backups/${backup.id}`, { password, timeout: 20 * 60 * 1000 });
}

export function downloadBackup(backup) {
  return Http.download(`/backups/file/${backup.id}`, {}, `(${backup.name})-${backup.filename}`);
}

export function importBackup(e) {
  return Http.upload('/backups/file', { timeout: 20 * 60 * 1000 }, e);
}

export function getCommPrograms(limit = 10, platform) {
  return Http.get('/commprograms/versions', { limit, platform });
}

export function uploadCommProgram(e) {
  return Http.upload('/commprograms/file', { timeout: 20 * 60 * 1000 }, e);
}

export function deleteCommProgram(program) {
  return Http.delete(`/commprograms/${program.name}`);
}

export function getLatestCommProgram(platform) {
  return Http.get('/commprograms/latest', { platform });
}

export function getApps(limit = 10) {
  return Http.get('/apks/versions', { limit });
}

export function uploadApp(e) {
  return Http.upload('/apks/file', { timeout: 20 * 60 * 1000 }, e);
}

export function deleteApp(app) {
  return Http.delete(`/apks/${app.name}`);
}

export function getLatestApp() {
  return Http.get('/apks/latest');
}

export function setupQRAddress(url) {
  return Http.post('/apks/qr', {
    url,
  });
}

export function setupQREnabled(enabled) {
  return Http.post('/apks/qr', {
    enabled,
  });
}

export function switchTask(status) {
  return Http.post('/system/advanced-settings', {
    task: status,
  });
}

export function switchEmergency(status) {
  return Http.post('/system/emergency', {
    emergency: status,
  });
}

export function switchPwdLevel(pwdlevel) {
  return Http.post('/system/pwdlevel', {
    pwdlevel,
  });
}
export function switchKeyBox(keybox, takeouttime) {
  return Http.post('/system/keybox', {
    keybox,
    takeouttime,
  });
}
export function switchKeycabinet(keycabinet, timeout) {
  return Http.post('/system/keycabinet', {
    keycabinet,
    timeout,
  });
}

export function switchELCBoxLock(elc) {
  return Http.post('/system/elc', {
    elc,
  });
}

export function getELCParams() {
  return Http.get('/system/elc/params');
}

export function updateELCParams(params) {
  return Http.post('/system/elc/params', params);
}

export function updateLic(dist) {
  return Http.post('/system/lic', dist);
}

export function updateMapKey(amapkey) {
  return Http.post('/system/amapkey', { amapkey });
}

export function updateGoogleMapKey(googlemapkey) {
  return Http.post('/system/googlemapkey', { googlemapkey });
}

export function updateAuthperiod(authperiod) {
  return Http.post('/system/authperiod', { authperiod });
}

export function getEditionRequestCode(type) {
  return Http.get(`/system/edition/request_code?type=${type}`);
}

export function verifyEditionActivateCode(code) {
  return Http.post('/system/edition/activate_code', { code });
}

export function getMqttEncryptPassword(password) {
  return Http.post('/system/mqtt/encrypt/password', {
    password,
  });
}
